import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 16px;

  section {
    display: flex;
    flex-direction: row;
    gap: 16px;
  }
`
